import servicesImage1 from './images/img1.png';
import servicesImage2 from './images/img2.png';
import servicesImage3 from './images/img3.png';
import servicesImage4 from './images/img4.png';
import servicesImage5 from './images/img5.png';
import servicesImage6 from './images/img6.png';
import servicesImage7 from './images/img7.png';
import servicesImage8 from './images/img8.png';
import servicesImage9 from './images/img9.jpg';
import servicesImage10 from './images/img10.jpg';
import servicesImage11 from './images/img11.png';
import servicesImage12 from './images/img12.jpg';
import servicesImage13 from './images/img13.jpeg';
import servicesImage14 from './images/img14.jpg';
import servicesImage15 from './images/img15.jpeg';

export const listServices = [
  {
    id: 1,
    img: servicesImage1,
    title: 'title1',
    description: 'description1',
    isImage: false,
  },
  {
    id: 2,
    img: servicesImage2,
    title: 'title2',
    description: 'description2',
    isImage: false,
  },
  {
    id: 3,
    img: servicesImage3,
    title: 'title3',
    description: 'description3',
    isImage: false,
  },
  {
    id: 4,
    img: servicesImage4,
    title: 'title4',
    description: 'description4',
    isImage: false,
  },
  {
    id: 5,
    img: servicesImage5,
    title: 'title5',
    description: 'description5',
    isImage: false,
  },
  {
    id: 6,
    img: servicesImage6,
    title: 'title6',
    description: 'description6',
    isImage: false,
  },
  {
    id: 7,
    img: servicesImage7,
    title: 'title7',
    description: 'description7',
    isImage: false,
  },
  {
    id: 8,
    img: servicesImage8,
    title: 'title8',
    description: 'description8',
    isImage: false,
  },
  {
    id: 9,
    img: servicesImage9,
    title: 'title9',
    description: 'description9',
    isImage: false,
  },
  {
    id: 10,
    img: servicesImage10,
    title: 'title10',
    description: 'description10',
    isImage: false,
  },
  {
    id: 11,
    img: servicesImage11,
    title: 'title11',
    description: 'description11',
    isImage: false,
  },
  {
    id: 12,
    img: servicesImage12,
    title: 'title12',
    description: 'description12',
    isImage: false,
  },
  {
    id: 13,
    img: servicesImage13,
    title: 'title13',
    description: 'description13',
    isImage: false,
  },
  {
    id: 14,
    img: servicesImage14,
    title: 'title14',
    description: 'description14',
    isImage: false,
  },
  {
    id: 15,
    img: servicesImage15,
    title: 'title15',
    description: 'description15',
    isImage: false,
  },
];
